<div class="site-search-list custom-input flex-column justify-start align-stretch gap-10">
  <!-- Header (Recheche)-->
  <form [formGroup]="searchForm"
    class="site-search-header flex-row gap-10 justify-start align-start">
    <!-- Boutton retour/annuler-->
    <button class="site-search-header-back"
      type="button"
      mat-icon-button
      (click)="onCancelClick($event)">
      <mat-icon class="show-gt-xs">close</mat-icon>
      <mat-icon class="hide-gt-xs">arrow_back</mat-icon>
    </button>

    <!-- Barre de recherche -->
    @if (!data.byLocation) {
      <mat-form-field>
        <mat-label>{{ "WELCOME.SEARCH.PLACEHOLDER" | transloco }}</mat-label>
        <input type="text"
          formControlName="searchValue"
          matInput
          autocomplete="off"
          [appAutofocus]="true"
          #searchValue />
          <!-- icones et spinner-->
          @if (canClear && !isLoading) {
            <mat-icon
              matSuffix
            (click)="onClearSearchValue()">clear</mat-icon>
          }
          @if (isLoading) {
            <mat-spinner matSuffix
            diameter="20"></mat-spinner>
          }
        </mat-form-field>
      }

      <!-- Autour de moi-->
      @if (data.byLocation) {
        <div class="site-search-location flex-row justify-between align-center"
          >
          <div class="flex-row justify-start align-center gap-10">
            <mat-icon class="site-search-location-icon"
            color="primary">gps_fixed</mat-icon>
            <div>{{ "WELCOME.SEARCH.AROUND_ME" | transloco }}</div>
          </div>
          @if (isLoading) {
            <mat-spinner
            diameter="20"></mat-spinner>
          }
        </div>
      }
    </form>

    <!-- Liste Sites trouvés -->
    @if (sites && sites.length > 0) {
      <div
        class="site-search-result flex-column gap-10">
        <!-- title-->
        <!-- <div class="site-search-result-title heading">Sites trouvés</div> -->
        <!-- Liste-->
        <div class="site-search-result-list flex-column">
          @for (site of sites; track site) {
            <div
              matRipple
              (click)="onSelectSite(site)"
              class="site-search-result-item flex-row justify-start align-center gap-10">
              <mat-icon class="site-search-result-icon">location_on</mat-icon>
              <div class="site-search-infos flex-column">
                <div class="site-search-name"><span>{{ site.name }}</span>@if (data.searchMode==='restaurant') {
                <span>, {{ site.restaurants[0].name}}</span>
              }</div>
              <div class="site-search-address">{{ site.address }}</div>
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if (isLoading) {
    <div class="site-search-loading-container"
      >
      <!-- content-place-holder-->
      @for (i of [1,2,3]; track i) {
        <content-loader
          [viewBox]="null"
          [style]="{'width':'100%', 'height':'100%'}"
          class="site-search-loading-item">
          <svg:circle cx="15" cy="15" r="8" />
          <svg:rect prima x="40" y="0" rx="3" ry="3" width="40%" height="12" />
          <svg:rect x="40" y="22" rx="3" ry="3" width="60%" height="10" />
        </content-loader>
      }
    </div>
  }

  <!-- aucun site trouvé-->
  @if (searchNoResult) {
    <div class="site-search-no-result"
      >
      <app-site-search-no-result [byLocation]="data.byLocation"
      (retry)="onSearchRetry($event)"></app-site-search-no-result>
    </div>
  }
</div>
